type BlogCategoryListingSeoInput = {
  categoryTitle: string;
  metaTitle?: string | null;
  metaDescription?: string | null;
  pageTitle?: string | null;
  pageDescription?: string | null;
  blogTitle: string;
  blogDescription: string;
};

const trimmed = (value?: string | null) => value?.trim() || '';

export const blogCategoryListingSeo = ({
  categoryTitle,
  metaTitle,
  metaDescription,
  pageTitle,
  pageDescription,
  blogTitle,
  blogDescription,
}: BlogCategoryListingSeoInput) => {
  const title =
    trimmed(metaTitle) ||
    trimmed(pageTitle) ||
    `${categoryTitle} | ${blogTitle}`;
  const description =
    trimmed(metaDescription) || trimmed(pageDescription) || blogDescription;

  return { title, description };
};
